<template>
  <ul>
    <vertical-nav-menu-items
      :items="itemMenuGroup"
      class="navigation navigation-main"
    />
  </ul>
  <!-- <div class="main-menu-manage-news-filter">
    
    <li
      class="nav-item cursor-pointer"
      v-for="(item, index) in eventStatus"
      :key="index"
      :class="{ selected: currentEventStatus(item) }"
      @click="selectEventStatus(item)"
    >
      <div class="item-icon">
        <feather-icon :icon="item.icon" />
      </div>
      <div class="item-name d-flex align-items-center text-truncate">
        {{ item.name }}
      </div>
      <div class="item-status">
        <b-badge pill class="badge-status">{{ item.total }}</b-badge>
      </div>
    </li>
  </div> -->
</template>

<script>
// import { BBadge } from "bootstrap-vue";
import AppConstants from "@/appConstants";
import VerticalNavMenuItems from "../vertical-nav-menu-items/VerticalNavMenuItems.vue";
import newsService from '@/providers/newsService';
// import { ref } from "@vue/composition-api";

export default {
  components: {
    // BBadge,
    VerticalNavMenuItems,
  },
  computed: {
    eventStatus() {
      return this.$store.state.manageNews.event_status;
    },
    isDashboardNavigation() {
      const currentRouteQuery = JSON.parse(JSON.stringify(this.$route.query));
      if (currentRouteQuery.dashboard) {
        return true;
      }
      return false;
    },
  },
  watch: {
    eventStatus(val) {
      this.itemMenuGroup = this.buildPublicationMenu(val);
    },
  },
  methods: {
    loadEventStatusStatistic() {
      const params = new URLSearchParams();
      params.append("event_status", AppConstants.EVENT_STATUS.PUBLISHED);
      params.append("status", true);
      params.append(AppConstants.PARAMS_USER_FILTER, true);
      newsService
        .getEventStatusWithStatistic(params)
        .then((res) => {
          this.$store.dispatch("manageNews/updateEventStatus", res);
        })
        .catch((err) => console.log(err));
    },
    buildPublicationMenu(statusList = []) {
      if (!statusList || statusList.length === 0) {
        return [];
      }

      const order = {
        [AppConstants.EVENT_STATUS.PUBLISHED]: 1,
        [AppConstants.EVENT_STATUS.SAVED]: 2,
        [AppConstants.EVENT_STATUS.SCHEDULED]: 3,
        [AppConstants.EVENT_STATUS.CANCELED]: 4,
        [AppConstants.EVENT_STATUS.EDITING]: 5,
        [AppConstants.EVENT_STATUS.DRAFT]: 6,
        [AppConstants.EVENT_STATUS.TEMPLATE]: 7,
      };

      const fallbackIcon = {
        [AppConstants.EVENT_STATUS.PUBLISHED]: 'MailIcon',
        [AppConstants.EVENT_STATUS.SAVED]: 'ArchiveIcon',
        [AppConstants.EVENT_STATUS.SCHEDULED]: 'SendIcon',
        [AppConstants.EVENT_STATUS.CANCELED]: 'InfoIcon',
        [AppConstants.EVENT_STATUS.EDITING]: 'EditIcon',
        [AppConstants.EVENT_STATUS.DRAFT]: 'Edit3Icon',
        [AppConstants.EVENT_STATUS.TEMPLATE]: 'ColumnsIcon',
      };

      const children = [...statusList]
        .sort((a, b) => {
          const first = order[a.id] || 999;
          const second = order[b.id] || 999;
          return first - second;
        })
        .map((item) => ({
          ...item,
          icon: item.icon || fallbackIcon[item.id] || 'CircleIcon',
        }));

      // return [{ header: this.$t('MAIN_MENU').Publications }].concat(children);
      // return [{
      //   title: this.$t('MAIN_MENU').Publications,
      //   icon: 'BookOpenIcon',
      //   isEventStatus: true,
      //   children,
      // }];

      return [
        {
          title: this.$t('MAIN_MENU').Publications,
          icon: 'BookOpenIcon',
          isEventStatus: true,
          children,
        },
      ];
    },
    navigateDashboard() {
      if (this.$route.path != AppConstants.NAVIGATION_PAGE_MANAGE_NEWS) {
        this.$router
          .push({
            path: AppConstants.NAVIGATION_PAGE_MANAGE_NEWS,
            query: { dashboard: true },
          })
          .catch(() => {});
      } else {
        const currentRouteQuery = JSON.parse(JSON.stringify(this.$route.query));
        currentRouteQuery.dashboard = true;
        this.$router.replace({ query: currentRouteQuery }).catch(() => {});
      }
    },
    getTotal(item) {
      if (item.id == AppConstants.EVENT_STATUS.DRAFT) {
        return this.$store.state.manageNews.draft_news.length;
      }
      return item.total;
    },
    currentEventStatus(item) {
      return this.$store.state.manageNews.currentEventStatus.id == item.id;
    },
    selectEventStatus(item) {
      this.$store.dispatch("manageNews/updateCurrentEventStatus", item);
      if (this.$route.path != AppConstants.NAVIGATION_PAGE_MANAGE_NEWS) {
        this.$router
          .push({
            path: AppConstants.NAVIGATION_PAGE_MANAGE_NEWS,
            query: { event_status: item.id },
          })
          .catch(() => {});
      }
    },
  },
  data() {
    return {
      itemMenuGroup: [],
    };
  },
  created() {
    this.itemMenuGroup = this.buildPublicationMenu(this.eventStatus);
    // onReady: na primeira carga o layout pode montar antes da navegação inicial resolver ($route ainda em "/").
    // Na tela de publicações o ManageNews já busca a contagem com os filtros aplicados.
    this.$router.onReady(() => {
      if (
        this.$store.state.auth.isAuthenticated &&
        this.$route.path != AppConstants.NAVIGATION_PAGE_MANAGE_NEWS
      ) {
        this.loadEventStatusStatistic();
      }
    });
  },
  setup() {},
  beforeCreate() {
    // if (!this.eventStatus) {
    //   // UPDATE PUBLISH MENU
    //   const params = new URLSearchParams();
    //   params.append("status", true);
    //   newsService
    //     .getEventStatusWithStatistic(params)
    //     .then((res) => {
    //       this.$store.dispatch("manageNews/updateEventStatus", res);
    //       setTimeout(() => {
    //         this.$forceUpdate();
    //       }, 500);
    //     })
    //     .catch();
    // }
  },
};
</script>

<style lang="scss">
.main-menu-manage-news-filter {
  .nav-item {
    display: flex;
  }
  .nav-item .item-name {
    text-overflow: ellipsis;
    margin: 0 15px;
    padding: 10px 10px 10px 10px;
    font-size: 15px;
    font-weight: 500;

    // &:hover {
    //     transform: translateY(-2px);
    //     box-shadow: 0 3px 5px 0 #AAA;
    //     transition: all 0.2s;
    //     z-index: 1;
    // }
  }
  .selected {
    border-left-style: solid;
    border-left-width: 3px;
    border-left-color: #0273aa;
    color: #0273aa;
    background-color: #f0faff;
  }
  .item-icon {
    padding: 10px;
  }
  .item-status {
    position: absolute;
    right: 10px;
    top: 10px;
    .badge-pill {
      // float: right;
      margin-top: -32px;
      margin-right: 12px;
      background-color: #fff;
      color: #606060;
    }
  }
}
</style>
